var map = {
	"./jfd/ja.json": "lWRo",
	"./ymk/ja.json": "0jS9"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "09QT";


//////////////////
// WEBPACK FOOTER
// ./src/app/lang/modules ^\.\/.*\.json$
// module id = 09QT
// module chunks = 120